<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd"
          d="M20.2071 7.83027C20.4024 8.02553 20.4024 8.34211 20.2071 8.53737L10.1036 18.6409C9.9083 18.8362 9.59171 18.8362 9.39645 18.6409L3.7929 13.0374C3.59764 12.8421 3.59764 12.5255 3.7929 12.3303L5.20711 10.9161C5.40238 10.7208 5.71896 10.7208 5.91422 10.9161L9.75001 14.7518L18.0858 6.41605C18.2811 6.22079 18.5976 6.22079 18.7929 6.41605L20.2071 7.83027Z"
          fill="#738288" />
  </svg>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
